import * as React from 'react'
import { observer } from 'mobx-react'
import { breakpointStore } from '../../../stores'
import { FilterBarMobile } from './filter-bar-mobile'
import { FilterBarDesktop } from './filter-bar-desktop'
import './filter-bar.scss'

@observer
export class CollectionsFilterBar extends React.Component {
  static HEIGHT: number = 104

  render(): React.ReactNode {
    return (
        <div className="filter-bar">
          <div className="container container--flush">
            {breakpointStore.breakpoint.above.md
              ? <FilterBarDesktop />
              : <FilterBarMobile />
            }
          </div>
        </div>
    )
  }
}
